<template>
    <div>
      <el-dialog
        :title="title"
        :close-on-click-modal="false"
        @close="onClose"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        :visible="visible"
        width="560px">
        <div v-loading="payLoading">
          <template v-if="paystate != 0">
            <h3 class="tips-line"><span class="el-icon-warning"></span> 请在新打开的页面内完成支付</h3>
            <p class="tips-line">充值订单号：{{ id }}</p>
            <p class="tips-line">支付完成前请不要关闭此窗口。</p>
            <p class="tips-line">如您已支付完成，请点击下方“我已支付完成”按钮。</p>
            <!-- <p class="tips-line">如您遇到任何问题，支付失败，请点击“查看帮助”按钮。</p>-->
            <p class="tips-line">支付成功后，将在24小时内到账。</p>
          </template>

          <template v-else>
            <h3 class="tips-line success"><span class="el-icon-success"></span> 充值成功！</h3>
            <p class="tips-line">充值订单号：{{ id }}</p>
            <p class="tips-line">恭喜，您已完成支付，本次充值成功！</p>
            <!-- <p class="tips-line">本次充值金额为：{{  }} 元</p> -->
            <p class="tips-line">如本次充值尚未到账，请稍后刷新页面即可。</p>
            <p class="tips-line">如超过24小时仍未到账，请与我们联系。</p>
          </template>
        </div>

        <div slot="footer" class="dialog-footer">
          <template v-if="paystate != 0">
            <el-button type="success" @click="checkPayState" :disabled="payLoading">我已完成支付</el-button>
            <!--<el-button type="warning" :disabled="true">查看帮助</el-button>-->
            <el-button type="warning" @click="payAgain">重新支付</el-button>
          </template>
          <template v-else>
            <el-button type="success" @click="close" :disabled="payLoading">好的</el-button>
          </template>

        </div>
      </el-dialog>
    </div>
</template>

<script>
    export default {
      props:{
        title:{
          type:String
        },
        visible:{
          type:Boolean,
          default:false
        },
        id:{
          type:String
        },
        payLoading:{
          type:Boolean,
          default:false,
        },
        paystate:{
          type:Number
        }
      },
      methods:{
        onClose(){
          this.$emit('onClose');
        },
        // 我已完成支付
        checkPayState(){
          this.$emit('checkPayState');
        },
        // 重新支付
        payAgain(){
          this.$emit('payAgain');
        },
        close(){
          this.$emit('close');
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dialogs/DialogPay.vue